module.exports = __webpack_public_path__ + "static/media/reducer.edf3e1c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videoPlayer/reducer.png
// module id = 86
// module chunks = 0